export default __webpack_public_path__ + "3e4b5013b1dc0d40d9849d1097de67e5.png";